import React from 'react'

const AgbPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">AGB (Kurzfassung)</h1>
      <div className="space-y-4 text-gray-700 dark:text-gray-200 text-sm leading-relaxed">
        <p>
          Diese AGB regeln die Nutzung der Qualyz-Plattform. Mit Registrierung akzeptieren Sie diese Bedingungen.
        </p>
        <p><strong>Leistungen:</strong> Zugriff auf Screening-, Analyse- und Watchlist-Funktionen gemäß dem jeweils
          vereinbarten Leistungsumfang.</p>
        <p><strong>Nutzung:</strong> Accounts sind personengebunden. Weitergabe von Zugangsdaten ist untersagt.</p>
        {/* Vorlaeufige Fassung (Kim, 14.09.2026), rechtliche Pruefung steht aus.
            "Nur Vorsatz und grobe Fahrlaessigkeit" war in AGB unwirksam
            (§§ 307, 309 Nr. 7 BGB) -- dann haette die volle gesetzliche Haftung gegolten. */}
        <p><strong>Haftung:</strong> Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von
          Leben, Körper oder Gesundheit, nach dem Produkthaftungsgesetz und im Umfang einer übernommenen Garantie. Bei
          leichter Fahrlässigkeit haften wir nur für die Verletzung wesentlicher Vertragspflichten, also solcher
          Pflichten, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren
          Einhaltung Sie regelmäßig vertrauen dürfen; die Haftung ist dann auf den vorhersehbaren, vertragstypischen
          Schaden begrenzt. Im Übrigen ist die Haftung ausgeschlossen. Qualyz bietet keine Anlageberatung;
          Anlageentscheidungen treffen Sie in eigener Verantwortung.</p>
        <p><strong>Kündigung:</strong> Accounts können jederzeit gekündigt werden; bereits gezahlte Entgelte werden
          nicht erstattet, sofern nicht gesetzlich vorgeschrieben.</p>
        <p><strong>Gerichtsstand/Anwendbares Recht:</strong> Es gilt deutsches Recht. Gerichtsstand ist der Sitz des
          Anbieters, sofern gesetzlich zulässig.</p>
      </div>
    </div>
  )
}

export default AgbPage




